import { render } from "./Data-table.vue?vue&type=template&id=1d3481c3&ts=true"
import script from "./Data-table.vue?vue&type=script&lang=ts"
export * from "./Data-table.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__